import { IHelpItem } from './IHelpItem';
import { IFaq } from './IFaq';

export interface ISearchResponse {
  content: ISearchResult[];
  lastEvaluatedKey: string;
}

export interface ISearchResult {
  type: SearchResultType;
  entry: IHelpItem | IFaq;
}

export interface ISearchParams {
  tenant: string;
  language: string;
  searchTerm: string;
  limit: number;
  startKey?: string;
}

export type SearchResultType = SEARCH_RESULT_TYPE;

export enum SEARCH_RESULT_TYPE {
  CATEGORY = 'category',
  FAQ = 'faq',
  HELP_ITEM = 'helpItem'
}
